exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.block-sliders-navigation .swiper-pagination-bullet {\n  margin: 0 2px;\n}\n", ""]);

// exports
